import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const WeekHeader = styled.div`
  display: grid;
  grid-template-columns: 304px 1fr;
  column-gap: 24px;
  align-items: center;
  padding: 16px 24px;
  border-radius: 24px;
  background: ${ColorV2.White};
  width: 100%;
  height: 103px;
  max-width: 100%;
  margin-top: 16px;
`;

export const WeekView = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`;

export const DaysRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  align-items: center;
  column-gap: 16px;
  width: 100%;
  min-width: 0;
`;

export const DayCard = styled.div<{ $isToday: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 16px;
  flex: 1 1 0;
  min-width: 0;
  background: ${(props) => (props.$isToday ? ColorV2.Blue7 : "transparent")};
`;

export const DayName = styled.div`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
`;

export const DayDate = styled.div<{ $isToday: boolean }>`
  ${TypographyV2.s1};
  color: ${(props) => (props.$isToday ? ColorV2.Blue1 : ColorV2.Blue4)};
`;
